import React, { Fragment, useEffect, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";

import { ChevronDown, ChevronUp, User, MapPin, Phone } from "lucide-react";
import PayIcon from "../../assets/icons/address-bar/pay-icon";
import ShipIcon from "../../assets/icons/address-bar/ship-icon";
import AddButton from "../buttons/button";
import { useDispatch } from "react-redux";
import { getAddress, valListAction } from "../../redux/actions/general-action";
import PersonIcon from "../../assets/icons/address-bar/person-icon";
import AddressIcon from "../../assets/icons/address-bar/address-icon";
import CallIcon from "../../assets/icons/address-bar/address-icon";
import NameIcon from "../../assets/icons/address-bar/name-icon";
import AddressTitleIcon from "../../assets/icons/address-bar/address-title-icon";
import errorToast from "../helper-components/error-toast";
import { useFormikContext } from "formik";
import AdminAddCustomer from "../../modules/customer-admin/add-customer";
import { useNavigate } from "react-router-dom";
import AdminEditCustomer from "../../modules/customer-admin/edit-customer";
import successToast from "../helper-components/success-toast";

const AddressSidebar = ({
  type,
  open,
  setOpen,
  id,
  disabled = false,
  name,
  page,
  path,
  handleDraft,
  // Optional direct callback, fired synchronously inside onSave with the
  // picked addresses. Existing callers that only rely on the `${name}_*`
  // Formik fields below are unaffected — this is additive.
  onSaved = () => {},
}) => {
  const [openSectionPay, setOpenSectionPay] = useState(null);
  const [openSectionShip, setOpenSectionShip] = useState(null);

  const [noAddress, setNoAddress] = useState(false);

  const [payList, setPayList] = useState([]);
  const [shipList, setShipList] = useState([]);
  const [savedPay, setSavedPay] = useState({});
  const [block, setBlock] = useState(false);

  const [savedShip, setSavedShip] = useState({});
  const { values, setFieldValue } = useFormikContext();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  console.log("900", id);
  console.log("800", block, name, page);

  useEffect(() => {
    if (type === "return") {
      setBlock(true);
    } else {
      setBlock(disabled);
    }
  }, [disabled, type]);
  const onSuccess = (data) => {
    console.log(":::::", data);
    const shipping = data?.data?.addressShipping || [];
    const pay = data?.data?.addressPay || [];

    console.log("::", shipping);
    // Always expose the full master list so the user can pick another address.
    setShipList(shipping);
    setPayList(pay);

    // The address flagged as default (falling back to the first one) is used as
    // the pre-selected value whenever the document hasn't saved its own address.
    const defaultShip =
      shipping.find((a) => a?.cmr_default_address) || shipping[0] || null;
    const defaultPay = pay.find((a) => a?.cmr_default_address) || pay[0] || null;
    const defaultShipId = defaultShip?.cmr_ship_address_id ?? null;
    const defaultPayId = defaultPay?.cmr_pay_address_id ?? null;

    if (page === "add" && type === "billing") {
      console.log("add billing");
      setOpenSectionShip(defaultShipId);
      setOpenSectionPay(defaultPayId);
    } else {
      console.log(
        "view billing",
        values,
        name,
        values[`${name}_pay_to_address`]
      );
      let payto = values[`${name}_pay_to_address`];
      let shipto = values[`${name}_ship_to_address`];
      if (page === "view") {
        // Show the address saved on the document. When one side is missing,
        // fall back to the default from the master list instead of "No Address".
        const shipShown = shipto || defaultShip;
        const payShown = payto || defaultPay;
        if (!shipShown && !payShown) {
          setNoAddress(true);
        } else {
          setShipList(shipShown ? [shipShown] : []);
          setPayList(payShown ? [payShown] : []);
        }
      }

      console.log("payto", payto?.cmr_pay_address_id);
      console.log("shipto", shipto?.cmr_ship_address_id);
      // Pre-select the document's saved address; otherwise fall back to the
      // default address returned by the API.
      setOpenSectionShip(shipto?.cmr_ship_address_id ?? defaultShipId);
      setOpenSectionPay(payto?.cmr_pay_address_id ?? defaultPayId);
    }
  };
  const onError = (data) => {
    // errorToast("could not fetch address");
  };
  // useEffect(() => {
  //   if (page !== "add") {
  //     let payto = values[`${name}_pay_to_address`];
  //     let shipto = values[`${name}_ship_to_address`];
  //     console.log(payto, shipto);
  //     if (payto && payto.cmr_pay_address_id) {
  //       console.log("payto", payto, typeof payto, payto && Object.keys(payto));

  //       setOpenSectionShip(payto.cmr_pay_address_id);
  //       setOpenSectionPay(shipto.cmr_ship_address_id);
  //     }
  //   }
  // }, [values]);
  useEffect(() => {
    // if (page !== "add") {
    //   console.log("payto", payto);
    //   setPayList(payto);
    //   setShipList(shipto);
    // }
    // console.log("99", values.cmr_id);
    // let finalId = id;
    // if (page !== "add") finalId = values.cmr_id;
    // console.log("finalId", finalId);
    if (type === "return") {
      console.log(
        "retuuuuuuuuuuurn",
        type === "return",
        values.icn_ship_from_address,
        values.icn_ship_from_address !== null
      );
      if (values.icn_ship_from_address) {
        setOpenSectionShip(values.icn_ship_from_address);
      } else {
        setNoAddress(true);
      }
    } else {
      dispatch(getAddress(id, onSuccess, onError));
    }
  }, [id]);

  const AddressCard = ({ address, onClose }) => (
    <div className="bg-[var(--address-open-bg)] border-2 border-[var(--address-open-border-color)] rounded-lg py-5 pl-5 pr-[10px] flex flex-col gap-5">
      {/* <FetchAddress
        id={id}
        setOpenSectionShip={setOpenSectionShip}
        setOpenSectionPay={setOpenSectionPay}
        setShipList={setShipList}
        setPayList={setPayList}
      /> */}
      {console.log("==", values)}
      <div className="flex justify-between ">
        <div className="flex items-center gap-3">
          <NameIcon />
          <label className="text-[length:var(--address-title-fs)] font-[var(--address-title-fw)]">
            {address.name}
          </label>
        </div>
        {address?.default ? (
          <div className="bg-[var(--address-icon1-fg)] px-2 py-1 rounded-full ">
            <span className="text-[var(--address-default-fg)] text-[length:var(--address-default-fs)] font-[var(--address-default-fw)]">
              Default
            </span>
          </div>
        ) : (
          <ChevronUp className="w-5 h-5 cursor-pointer" onClick={onClose} />
        )}
      </div>
      <div className="flex items-start gap-3">
        <AddressIcon />
        <span className=" text-[length:var(--address-text-fs)] font-[var(--address-text-fw)]">
          {address.address.filter(Boolean).join(", ")}
        </span>
      </div>
    </div>
  );

  const AddressSection = ({
    title,
    icon,
    addresses,
    openSection,
    setOpenSection,
    sectionType, // 'pay' or 'ship'
  }) => {
    // Create refs for each address item
    const itemRefs = useRef({});

    // Effect to scroll the opened item into view
    // useEffect(() => {
    //   if (openSection && itemRefs.current[openSection]) {
    //     // Use setTimeout to ensure the DOM has updated after state change
    //     setTimeout(() => {
    //       const element = itemRefs.current[openSection];
    //       const container = element.closest(".tab-container");

    //       if (container && element) {
    //         // Calculate the position of the element relative to the container
    //         const containerRect = container.getBoundingClientRect();
    //         const elementRect = element.getBoundingClientRect();

    //         // Scroll only if the element is not fully visible
    //         const isVisible =
    //           elementRect.top >= containerRect.top &&
    //           elementRect.bottom <= containerRect.bottom;

    //         if (!isVisible) {
    //           element.scrollIntoView({
    //             behavior: "smooth",
    //             block: "nearest",
    //             inline: "nearest",
    //           });
    //         }
    //       }
    //     }, 50); // Small delay to ensure DOM update
    //   }
    // }, [openSection]);
    useEffect(() => {
      if (openSection && itemRefs.current[openSection]) {
        setTimeout(() => {
          const element = itemRefs.current[openSection];
          if (!element) return; // Prevents the 'closest' error

          const container = element.closest(".tab-container");
          if (!container) return;

          const containerRect = container.getBoundingClientRect();
          const elementRect = element.getBoundingClientRect();

          const isVisible =
            elementRect.top >= containerRect.top &&
            elementRect.bottom <= containerRect.bottom;

          if (!isVisible) {
            element.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "nearest",
            });
          }
        }, 50);
      }
    }, [openSection]);

    return (
      <div className="h-full flex flex-col gap-3">
        {/* Section Header */}
        <div className="flex items-center gap-3">
          <div
            className={`rounded-full ${
              sectionType === "pay"
                ? "bg-[var(--address-icon1-fg)]"
                : "bg-[var(--address-icon2-fg)]"
            } p-3`}
          >
            {icon}
          </div>
          <label className="text-[length:var(--address-title-fs)] font-[var(--address-title-fw)]">
            {title}
          </label>
        </div>

        {/* Scrollable List */}

        <div className="tab-container flex flex-col gap-3 overflow-y-auto flex-1 min-h-0">
          {addresses.map((item) => {
            const id =
              sectionType === "pay"
                ? item?.cmr_pay_address_id
                : item?.cmr_ship_address_id;
            const name =
              sectionType === "pay"
                ? item?.cmr_pay_address_name
                : item?.cmr_ship_address_name;
            const addressArr =
              sectionType === "pay"
                ? [
                    item?.cmr_pay_address_street,
                    item?.cmr_pay_address_city,
                    item?.cmr_pay_address_district,
                    item?.cmr_pay_address_state,
                    item?.cmr_pay_address_pincode,
                  ]
                : [
                    item?.cmr_ship_address_street,
                    item?.cmr_ship_address_city,
                    item?.cmr_ship_address_district,
                    item?.cmr_ship_address_state,
                    item?.cmr_ship_address_pincode,
                  ];
            const isDefault = item?.cmr_default_address;
            const phone = item?.phone || "";

            return (
              <div
                key={id}
                ref={(el) => {
                  if (el) {
                    itemRefs.current[id] = el;
                  } else {
                    delete itemRefs.current[id];
                  }
                }}
              >
                {/* Collapsed */}
                {openSection !== id && (
                  <div className="border-2 border-[var(--address-close-border-color)] rounded-lg">
                    <div
                      className="p-[10px] rounded-lg cursor-pointer flex items-center justify-between transition-all"
                      onClick={() => {
                        if (block) return;
                        else setOpenSection(id);
                      }}
                    >
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                          <NameIcon />
                        </div>
                        <label className="text-[length:var(--address-title-fs)] font-[var(--address-title-fw)]">
                          {name}
                        </label>
                      </div>
                      <ChevronDown className="w-5 h-5" />
                    </div>
                  </div>
                )}
                {console.log("block", block)}
                {/* Expanded */}
                {openSection === id && (
                  <AddressCard
                    address={{
                      name,
                      address: addressArr,
                      default: isDefault,
                    }}
                    onClose={() => {
                      if (block) return;
                      else setOpenSection(null);
                    }}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  const onSave = () => {
    if (block) return;
    else {
      console.log("888", openSectionShip, openSectionPay);
      if (openSectionPay === null || openSectionShip === null) {
        errorToast("select pay address and ship address to save");
      } else {
        let payData = payList.find(
          (item, index) => item?.cmr_pay_address_id === openSectionPay
        );
        let shipData = shipList.find(
          (item, index) => item?.cmr_ship_address_id === openSectionShip
        );
        let prefix = name;
        // if (section === "purchase") prefix = "pot";
        // else prefix = "sot";
        if (payData) setFieldValue(`${prefix}_pay_to_address`, payData);
        if (shipData) setFieldValue(`${prefix}_ship_to_address`, shipData);
        onSaved({ payData: payData || null, shipData: shipData || null });
        successToast("Address is saved");
        setOpen(false);
      }
    }
  };
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={() => {
          setOpen(false);
        }}
      >
        {console.log("shipList", shipList)}
        <div className="fixed inset-0 overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="absolute inset-0 bg-[#0000004D]" />
          </Transition.Child>

          <div className="fixed inset-0 flex justify-end">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-300"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-300"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <Dialog.Panel className="h-full w-[400px] sm:w-[537px] bg-white overflow-y-auto rounded-tl-lg rounded-bl-lg shadow-xl flex flex-col">
                {/* Header */}
                <div className="mb-5 p-4 bg-[var(--address-title-bg)]">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-[var(--address-icon2-fg)] flex items-center justify-center">
                      <AddressTitleIcon />
                    </div>
                    <h2 className="text-[length:var(--address-bold-fs)] font-[var(--address-bold-fw)]">
                      Address Details
                    </h2>
                  </div>
                </div>

                {/* MAIN SCROLLABLE CONTENT */}
                {noAddress ? (
                  <div className="flex-1 min-h-0 flex flex-col items-center gap-6 px-6">
                    <h2 className="text-[length:var(--address-bold-fs)] font-[var(--address-bold-fw)]">
                      No Address
                    </h2>
                  </div>
                ) : (
                  <div className="flex-1 min-h-0 flex flex-col gap-6 px-6">
                    {/* Pay-to Address section, 50% height, scrolls independently */}
                    <div className="h-1/2 min-h-0 flex flex-col">
                      {type !== "return" && (
                        <AddressSection
                          title="Pay-to Address"
                          icon={<PayIcon />}
                          addresses={payList}
                          openSection={openSectionPay}
                          setOpenSection={setOpenSectionPay}
                          sectionType="pay"
                        />
                      )}
                      {type === "return" && (
                        <div className="h-full flex flex-col gap-3">
                          {/* Section Header */}
                          <div className="flex items-center gap-3">
                            <div
                              className={`rounded-full ${"bg-[var(--address-icon2-fg)]"} p-3`}
                            >
                              <ShipIcon />
                            </div>
                            <label className="text-[length:var(--address-title-fs)] font-[var(--address-title-fw)]">
                              Ship-from Address
                            </label>
                          </div>
                          <AddressCard
                            address={{
                              name: values?.icn_ship_from_address
                                ?.cmr_ship_address_name,
                              address: [
                                values?.icn_ship_from_address
                                  ?.cmr_ship_address_street,
                                values?.icn_ship_from_address
                                  ?.cmr_ship_address_city,
                                values?.icn_ship_from_address
                                  ?.cmr_ship_address_district,
                                values?.icn_ship_from_address
                                  ?.cmr_ship_address_state,
                                values?.icn_ship_from_address
                                  ?.cmr_ship_address_pincode,
                              ],
                              default:
                                values.icn_ship_from_address
                                  ?.cmr_default_address,
                            }}
                            title="Ship-from Address"
                            icon={<ShipIcon />}
                            openSection={openSectionPay}
                            setOpenSection={setOpenSectionPay}
                            // sectionType="ship"
                          />
                        </div>

                        // <AddressSection
                        //   title="Ship-to Address"
                        //   icon={<ShipIcon />}
                        //   addresses={[values?.icn_ship_from_address]}
                        //   openSection={openSectionShip}
                        //   setOpenSection={setOpenSectionShip}
                        //   sectionType="pay"
                        // />
                      )}
                    </div>
                    {console.log("...", values)}
                    {/* Ship-to Address section, 50% height, scrolls independently */}
                    {type !== "return" && (
                      <div className="h-1/2 min-h-0 flex flex-col">
                        <AddressSection
                          title="Ship-to Address"
                          icon={<ShipIcon />}
                          addresses={shipList}
                          openSection={openSectionShip}
                          setOpenSection={setOpenSectionShip}
                          sectionType="ship"
                        />
                      </div>
                    )}
                  </div>
                )}

                {/* Footer Buttons */}
                <div className="p-4 mt-auto border-t border-gray-200 bg-white flex justify-between">
                  <AddButton
                    onclkFn={() => {
                      setOpen(false);
                    }}
                    prefixIcon={false}
                    text={<span>Cancel</span>}
                    className="flex items-center px-3 py-2 whitespace-nowrap rounded-md gap-[8px] bg-[var(--trans-stats-con-red-fg)] cursor-pointer text-white text-[length:var(--draft-button-fs)] font-[var(--draft-button-fw)]"
                    type="button"
                  />
                  {!block && (
                    <div className="flex gap-2">
                      <AddButton
                        prefixIcon={true}
                        onclkFn={() => {
                          if (block) return;
                          else {
                            handleDraft();
                            // navigate(
                            //   `/edit-customer-admin/${id}?from=${path}`,
                            //   {
                            //     state: { tab: "Address" },
                            //   }
                            // );
                          }
                        }}
                        text={"Add Address"}
                        className="flex items-center px-3 py-2 whitespace-nowrap rounded-md gap-[8px] bg-[var(--primary-button-bg-color)] cursor-pointer text-[var(--primary-button-fg-color)] border border-[var(--primary-button-bg-color)] hover:bg-[var(--primary-button-hover-color)] text-[length:var(--primary-button-create-fs)] font-[var(--primary-button-font-weight)]"
                        type="button"
                      />
                      {!noAddress && (
                        <AddButton
                          onclkFn={() => {
                            onSave();
                          }}
                          prefixIcon={false}
                          text={<span>Save</span>}
                          className="flex items-center px-3 py-2 whitespace-nowrap rounded-md gap-[8px] bg-[var(--primary-button-bg-color)] cursor-pointer text-[var(--primary-button-fg-color)] border border-[var(--primary-button-bg-color)] hover:bg-[var(--primary-button-hover-color)] text-[length:var(--primary-button-create-fs)] font-[var(--primary-button-font-weight)]"
                          type="button"
                        />
                      )}
                    </div>
                  )}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
export default AddressSidebar;

function FetchAddress({
  //   id,
  setOpenSectionShip,
  setOpenSectionPay,
  setShipList,
  setPayList,
}) {
  const dispatch = useDispatch();
  const { values, setFieldValue } = useFormikContext();
  const onSuccess = (data) => {
    setOpenSectionShip(data?.data?.addressShipping[0].cmr_ship_address_id);
    setOpenSectionPay(data?.data?.addressPay[0].cmr_pay_address_id);

    setShipList(data?.data?.addressShipping || []);
    setPayList(data?.data?.addressPay || []);
  };
  useEffect(() => {
    dispatch(getAddress(values?.cmr_id, onSuccess, () => {}));
    return null;
  }, []);
}
